exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-main[data-v-078753dd] {\n    /*50 = navbar  */\n    min-height: calc(100vh - 50px);\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n    padding: 15px;\n}\n.fixed-header + .app-main[data-v-078753dd] {\n    padding-top: 50px;\n}\n", ""]);

// exports
